// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._component-icon-next[data-v-7e70390a] {\n  width: 20px;\n  height: 20px;\n}\n._component-icon-next path[data-v-7e70390a] {\n  fill: inherit;\n}\n", ""]);
// Exports
module.exports = exports;
